import React, { Box } from '@mui/material';
import { FC } from 'react';
import { useStyles } from './UnknownUserAvatar.styles';
import icon from 'assets/images/avatar_placeholder.png';

export const UnknownUserAvatar: FC = () => {
  const { classes } = useStyles();

  return (
    <Box className={classes.root}>
      <img src={icon} className="img-fluid" />
    </Box>
  );
};
